// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import VueLazyload from 'vue-lazyload';

Vue.use(HzComponents);
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'static/error.png',
  loading: '',
  attempt: 1
});

import './assets/js/jquery-3.1.1.min';

// 引入字体文件
import './assets/fonts/swis.css';

// 引入样式文件
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.css';
import './assets/css/myAnimate.css';
import './assets/css/right.css';

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  watch: {
    frontierArticle: {
      deep: true,
      handler: function () {
        sessionStorage.setItem('frontierArticle', JSON.stringify(this.frontierArticle))
      }
    },
    frontierTag: {
      deep: true,
      handler: function () {
        sessionStorage.setItem('frontierTag', JSON.stringify(this.frontierTag))
      }
    },
    channelId: {
      deep: true,
      handler: function () {
        sessionStorage.setItem('channelId',this.channelId)
      }
    }

  },
  mounted() {
    if (sessionStorage.getItem('frontierArticle'))
      this.$root.frontierArticle = JSON.parse(sessionStorage.getItem('frontierArticle'))
    if (sessionStorage.getItem('frontierTag'))
      this.$root.frontierTag = JSON.parse(sessionStorage.getItem('frontierTag'))
    if (sessionStorage.getItem('channelId'))
      this.$root.channelId = sessionStorage.getItem('channelId')
  },
  data() {
    return {
      frontierTag: {},
      frontierArticle: {},
      channelId: ''
    }
  },
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js